<template>
  <div id="app" >
   <printable-lesson :lessonUid="lessonUid" />
  </div>
</template>

<script lang="ts">
import { Inject, Provide, Vue,Options } from 'vue-property-decorator';  
import PrintableLesson from '@/components/course/PrintableLesson.vue'
import { EntryRepository } from '@/data/repository/EntryRepository';
import { EmurseContext } from '@/EmurseCore';

class PrintLessonAppModel
{
  constructor(){}
} 

@Options({
  components: {PrintableLesson} 
})
export default class PrintLessonApp extends Vue
{ 
  @Inject() lessonUid!: string;
  @Inject() private entryRepository!: EntryRepository;
  @Provide("emurseContext") private emurseContext: EmurseContext = new EmurseContext("print",false);

  public created()
  {
    this.emurseContext.entryRepository = this.entryRepository;
  }
}
</script> 
